export default __webpack_public_path__ + "static/media/15.d39a7dbf.png";